import { __awaiter, __generator } from "tslib";
import { createDebugLogger } from '../../modules/_core/utils/app-utils';
import { api } from '../../modules/_core/utils/api-helpers';
var debug = createDebugLogger('RemoteLog');
var RemoteLog = /** @class */ (function () {
    function RemoteLog() {
        debug('Initializing RemoteLog');
    }
    RemoteLog.prototype.publish = function (_a) {
        var message = _a.message, level = _a.level, conversationId = _a.conversationId;
        return __awaiter(this, void 0, void 0, function () {
            var threadId, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        threadId = conversationId || this.conversationId || 'no_thread_id';
                        return [4 /*yield*/, api().saveLog(threadId, String(message), level).then()];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        e_1 = _b.sent();
                        debug('Publishing remote log failed.', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RemoteLog.prototype.debug = function (message, conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.publish({ message: message, level: 'DEBUG', conversationId: conversationId })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RemoteLog.prototype.info = function (message, conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.publish({ message: message, level: 'INFO', conversationId: conversationId })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RemoteLog.prototype.error = function (message, conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.publish({ message: message, level: 'ERROR', conversationId: conversationId })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return RemoteLog;
}());
var _remoteLog = new RemoteLog();
export var remoteLog = _remoteLog;
